exports.components = {
  "component---src-components-tgr-site-js": () => import("./../../../src/components/tgr_site.js" /* webpackChunkName: "component---src-components-tgr-site-js" */)
}

